import { type Format } from '@ugin/shared';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  defaultFormat: Format;
  reducedMotion: boolean;
  setDefaultFormat: (format: Format) => void;
  setReducedMotion: (value: boolean) => void;
}

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      defaultFormat: 'standard',
      reducedMotion: false,
      setDefaultFormat: (defaultFormat) => set({ defaultFormat }),
      setReducedMotion: (reducedMotion) => set({ reducedMotion }),
    }),
    {
      name: 'ugin-settings',
    },
  ),
);
